export interface IPricingPackage {
  id: string;
  name: string;
  description: string | null;
  features: IPricingFeature[];
  createdAt: Date;
  updatedAt: Date;
}

export interface IFixedPricing {
  price: number;
}

export interface IRangedPricing {
  minPrice: number;
  maxPrice: number;
}

export interface IPricingFeature {
  id: string;
  name: string;
  description: string | null;
  pricing: IFixedPricing | IRangedPricing;
  createdAt: Date;
  updatedAt: Date;
}

export interface IPricingPackageCreateObject
  extends Omit<IPricingPackage, 'createdAt' | 'updatedAt' | 'features'> {}

export interface IPricingPackageUpdateObject
  extends Pick<IPricingPackage, 'name' | 'description'> {}

export interface IPricingFeatureCreateObject
  extends Omit<IPricingFeature, 'createdAt' | 'updatedAt'> {
  packageId: string;
}

export interface IPricingFeatureUpdateObject
  extends Pick<IPricingFeature, 'name' | 'description' | 'pricing'> {}

export enum CouponType {
  FIXED = 'fixed',
  PERCENTAGE = 'percentage',
}

export interface ICoupon {
  id: string;
  featureId: string;
  title: string;
  availableFrom: Date | null;
  redeemableUntil: Date | null;
  type: CouponType;
  discount: number;
  code: string;
  description: string | null;
  createdAt: Date;
  updatedAt: Date;
}

export interface ICouponCreateObject
  extends Omit<ICoupon, 'createdAt' | 'updatedAt'> {}
export interface ICouponUpdateObject
  extends Pick<
    ICoupon,
    | 'featureId'
    | 'title'
    | 'availableFrom'
    | 'redeemableUntil'
    | 'type'
    | 'discount'
    | 'code'
    | 'description'
  > {}

export interface ICalculatedPricingFeature
  extends Omit<IPricingFeature, 'createdAt' | 'updatedAt'> {
  redeemedCoupon: ICoupon | null;
  discountedPricing: IFixedPricing | IRangedPricing | null;
}

export interface ICalculatedPricingPackage
  extends Omit<IPricingPackage, 'createdAt' | 'updatedAt' | 'features'> {
  features: ICalculatedPricingFeature[];
  totalPricing: IFixedPricing | IRangedPricing;
  totalDiscountedPricing: IFixedPricing | IRangedPricing | null;
}

export interface IPricingRequestQuery {
  coupon?: string;
}

export interface IPricingResponse extends ICalculatedPricingPackage {}

export interface IPricingOffer {
  id: string;
  customerId: string;
  offer: ICalculatedPricingPackage;
  createdAt: Date;
}

export interface IPricingOfferCreateRequest {
  couponCode?: string;
}

export interface IPricingOfferCreateObject
  extends Omit<IPricingOffer, 'createdAt'> {}
